import { defineStore, acceptHMRUpdate } from 'pinia'

export const useWishlistStore = defineStore('wishlistStore', () => {

    const wishlist = useLocalStorage<string[]>("wishlist", () => {
        return [];
      });
      
 
    const initialized = ref(false)

    async function init() {
        if (!initialized.value) {
            initialized.value = true
        }
    }

    // toggle wishlist
    const toggleWishlist = async(slug: string) => {

        const index = wishlist.value.indexOf(slug);
      
        if (index !== -1) {
          // Slug is in the wishlist, remove it
          wishlist.value.splice(index, 1);
        } else {
          // Slug is not in the wishlist, add it
          wishlist.value.push(slug);
        }
      };

 
 return {
    init, 
    wishlist,
    toggleWishlist,
 }
});

if ((import.meta as any).hot) {
 (import.meta as any).hot.accept(
 acceptHMRUpdate(useWishlistStore, (import.meta as any).hot)
);
}
